import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Text = _resolveComponent("Text")!

  return (Boolean(_ctx.errorMessage))
    ? (_openBlock(), _createBlock(_component_Text, {
        key: 0,
        class: "field-error",
        variant: "small"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}